import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './index.scss';
import MoreProduct from '../MoreProduct';
import ProductItem from '../ProductItem';
type productProps = {
  productData: any;
  ext: any;
};
const ProductList: React.FC<productProps> = ({ productData, ext }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data } = productData;
  const [type, setType] = useState(0);
  const [kind, setKind] = useState(0);
  const [group, setGroup] = useState(0);
  const [subList, setSubList] = useState<any[]>([]); //二级分类
  const [secondList, setSecondList] = useState([]);
  const [prokind, setProkind] = useState([]);

  // 第二层级
  useEffect(() => {
    setSubList(data[type].subNav);
  }, [type, kind, group, data]);

  // 第三层级
  useEffect(() => {
    // @ts-ignore
    setSecondList(subList?.[kind]?.subNav || []);
  }, [subList, kind]);

  // 产品数据层
  useEffect(() => {
    setProkind(
      // @ts-ignore
      secondList[group]?.page?.floors[0]?.products.data ||
        // @ts-ignore
        subList?.[kind]?.page?.floors[0]?.products.data ||
        []
    );
  }, [secondList, group]);

  // let prokind = secondList[group].subNav
  //   ? secondList[group].subNav[group].page.floors[0].products.data
  //   : data[kind].page.floors[0].products.data;
  // const proNum = prokind.length;

  //类别的选择事件
  const handleTypeChoice = (num: number, item: any) => {
    setGroup(0);
    setType(num);
    setKind(0);
    navigate(`/bxsc/${item.key}`);
  };

  //险种的选择事件
  const handleKindChoice = (num: number, item: any) => {
    setGroup(0);
    setKind(num);
    navigate(`/bxsc/${item.key}`);
  };
  const handleGroupChoice = (num: any) => {
    setGroup(num);
  };
  const handleToGetId = () => {
    data.forEach((item: any, index: any) => {
      if (item.key === id) setKind(index);
    });
  };

  useEffect(() => {
    handleToGetId();
  }, [location]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className='productList'>
      <div className='insure_kind'>
        <div className='kind_one'>
          <div className='kind_name'>按类别&nbsp;:</div>
          <div className='kind_value'>
            {data.map((item: any, index: any) => (
              <span
                key={index}
                className={index === type ? '_name_item' : 'name_item'}
                onClick={() => handleTypeChoice(index, item)}
              >
                {item.title}
              </span>
            ))}
          </div>
        </div>
        {subList && (
          <div className='kind_one kind_two'>
            <div className='kind_name'>{data[0].subDesc}&nbsp;:</div>
            <div className='kind_value'>
              {subList.map((item: any, index: any) => (
                <span
                  key={index}
                  className={index === kind ? '_name_item' : 'name_item'}
                  onClick={() => handleKindChoice(index, item)}
                >
                  {item.title}
                </span>
              ))}
            </div>
          </div>
        )}
        {secondList && secondList.length > 0 && (
          <div className='kind_one kind_two'>
            <div className='kind_name'>{subList?.[0]?.subDesc}:</div>
            <div className='kind_value'>
              {secondList.map((item: any, index: any) => (
                <span
                  key={index}
                  className={index === group ? '_name_item' : 'name_item'}
                  onClick={() => handleGroupChoice(index)}
                >
                  {item.title}
                </span>
              ))}
            </div>
          </div>
        )}
      </div>
      <div className='product_num'>
        共<span>{prokind?.length > 0 ? prokind?.length : 0}</span>款产品
      </div>
      <div className='product_all'>
        <ProductItem prokind={prokind} />
        <MoreProduct ext={ext} />
      </div>
    </div>
  );
};

export default ProductList;
